import React, { Component } from 'react';
import { Slider, Select } from '../../../../../../../styleguide';
import ColorPickerInput from '../../../../../../common/ColorPickerInput.js.jsx';
import { filterElements } from '../../../../../../../util.js';
import { isNSI } from '../../../../../../utils.js';
import { Checkbox } from 'antd/lib/index.js';

const { Option } = Select;

class Font extends Component {
  updateFont = (type, value) => {
    const font = JSON.parse(JSON.stringify(this.props.value));
    font[type] = value;
    this.props.updateSetting(this.props.settingKey, font);
  };
  render() {
    const {
      value,
      messageSubcategory,
      isNativeButton,
      accountId
    } = this.props;
    const filter = filterElements(messageSubcategory);

    return (
      <div className="four-options">
        {this.props.settingsTitle && (
          <h4>{this.props.settingsTitle}</h4>
        )}
        <div className="option-inputs">
          <div>
            <Select value={value.fontFamily} onChange={val => this.updateFont('fontFamily', val)} style={{ width: '100%' }}>
              <Option value='arial, helvetica, sans-serif' style={{ fontFamily: 'arial, helvetica, sans-serif' }}>Arial</Option>
              <Option value='comic sans ms,cursive' style={{ fontFamily: 'comic sans ms,cursive' }}>Comic Sans</Option>
              <Option value='courier new,courier,monospace' style={{ fontFamily: 'courier new,courier,monospace' }}>Courier New</Option>
              <Option value='georgia, serif' style={{ fontFamily: 'georgia, serif' }}>Georgia</Option>
              <Option value='lucida sans unicode,lucida grande,sans-serif' style={{ fontFamily: 'lucida sans unicode,lucida grande,sans-serif' }}>Lucida Sans</Option>
              <Option value='tahoma,geneva,sans-serif' style={{ fontFamily: 'tahoma,geneva,sans-serif' }}>Tahoma</Option>
              <Option value='times new roman,times,serif' style={{ fontFamily: 'times new roman,times,serif' }}>Times New Roman</Option>
              <Option value='trebuchet ms,helvetica,sans-serif' style={{ fontFamily: 'trebuchet ms,helvetica,sans-serif' }}>Trebuchet</Option>
              <Option value='verdana,geneva,sans-serif' style={{ fontFamily: 'verdana,geneva,sans-serif' }}>Verdana</Option>
              {isNSI(accountId) && (
                <Option
                  value='NSI, sans-serif'
                  style={{ fontFamily: 'NSI, sans-serif' }}
                >
                  NS&I Everyday
                </Option>
              )}
            </Select>
            <h5>Family</h5>
          </div>
          <div>
            <Select value={value.fontWeight} onChange={val => this.updateFont('fontWeight', val)} style={{ width: '100%' }}>
              <Option value="300" style={{ fontWeight: '300' }}>Light</Option>
              <Option value="400" style={{ fontWeight: '400' }}>Normal</Option>
              <Option value="500" style={{ fontWeight: '500' }}>Medium</Option>
              <Option value="600" style={{ fontWeight: '600' }}>Semi-bold</Option>
              <Option value="700" style={{ fontWeight: '700' }}>Bold</Option>
              <Option value="800" style={{ fontWeight: '800' }}>Heavy</Option>
            </Select>
            <h5>Weight</h5>
          </div>
        </div>
        <div className="option-inputs">
          <div style={{ paddingLeft: '3px' }}>
            <Slider min={1} max={128} step={1} tipFormatter={l => l + 'px'}
              onChange={val => this.updateFont('fontSize', val)}
              value={typeof value.fontSize === 'number' ? value.fontSize : 0}
            />
            <h5>Size</h5>
          </div>
          {!isNativeButton && (
            <>
              <div>
                <ColorPickerInput
                  value={value.color}
                  onUpdate={(value) => this.updateFont('color', value)}
                  editing={true}
                />
                <h5>Color</h5>
              </div>
              <div>
                <ColorPickerInput
                  value={value.disabledColor}
                  onUpdate={(value) => this.updateFont('disabledColor', value)}
                  editing={true}
                />
                <h5>Disabled Color</h5>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default Font;
